import { useMutation } from 'react-query';

import { updateProfile } from '../../../services/profile';


const useEditProfile = () => {

  const { isLoading, mutate: editProfile ,isSuccess } = useMutation({
    mutationFn: (payload: IUpdateProfilePayload) => {
      return updateProfile(payload);
    },
  });

  return { isLoading, editProfile  ,isSuccess};
};

export default useEditProfile;
